// extracted by mini-css-extract-plugin
module.exports = {"header":"SectionHeader_header__2MrTk","text":"SectionHeader_text__1ry_R","center":"SectionHeader_center__2STFy","title":"SectionHeader_title__3QJr7"};